<template>
    <div class="tsa-pendingPaymentTip" v-show="show" :class="type">
        <div class="left">
            <div class="single-container" v-if="orderInfo.count === 1">
                <p class="name">您有 <span>{{ orderInfo.count }}</span> 笔待支付订单，将在 <span class="size20">{{ countdownText }}</span> 后关闭 </p>
                <p class="btn" @click="continuePayOredr('用户中心_待支付订单-去支付')">
                    <span>去支付</span>
                </p>
            </div>
            <div class="multiple-container" v-if="orderInfo.count > 1">
                <div class="pending-number" @click="gotoOrderList">
                    <p>您有<span class="bold"> {{ orderInfo.count }} </span><span>笔待支付订单</span><span class="el-icon-arrow-right"></span></p>
                </div>
                <div class="order-info">
                    <p>订单1：{{orderInfo.order.id | replaceStr(3,9,'****')}}将在<span>{{ countdownText }}</span>后关闭</p>
                </div>
                <div class="timestamp-count">
                    <p>时间戳个数：{{orderInfo.order.tsCount}}个</p>
                    <p>待支付金额：<span>￥{{ orderInfo.order.payAmount }}</span></p>
                </div>
                <div class="btn-group">
                    <p class="cancel" @click="cancelOrder">
                        <span>取消订单</span>
                    </p>
                    <p class="confirm" @click="continuePayOredr('用户中心_待支付订单_继续支付')">
                        <span>继续支付</span>
                    </p>
                </div>
            </div>
        </div>
        <span class="el-icon-close" @click="close"></span>
    </div>
</template>

<script>
import { getPendingPaymentOrder} from "@http/overview/buy";
import { cancelOrderCommon, continuePayOredrCommon } from '@/common/order'
import { mapState } from 'vuex'
export default {
    props: {
        type: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            show: false,
            orderInfo: {},
            countdownText: ''
        }
    },
    computed: {
        ...mapState({
            uuserinfo: state => state.userInfo.userinfo
        })
    },
    mounted () {
        if (this.uuserinfo.parentId == '0') {
            this.getOrderInfo()
        }
        
    },
    beforeDestroy () {
        this.timer && clearInterval(this.timer)
    },
    methods: {
        gotoOrderList () {
            this.$router.push({
                path:'/order/orderList',
                query:{
                    tabVal:2
                }
            })
        },
        // 取消订单
        cancelOrder () {
            cancelOrderCommon(this.orderInfo).then((result) => {
                this.getOrderInfo()
                let page = ''
                switch (this.type) {
                    case 'home':
                        page = '工作台'
                        break
                    case 'userAccount_overview':
                        page = '账户总览'
                        break
                }
                this.$TsaOrderCancelSuccessDialog.show({
                    type: 1,
                    traceMap: {
                        page
                    }
                })
                zhuge.track('用户中心_待支付订单-取消订单', {
                    '页面名称': page
                })
            }).catch((err) => {
                
            });
        },
        // 继续支付
        continuePayOredr (traceText) {
            let page = ''
            switch (this.type) {
                case 'home':
                    page = '工作台'
                    break
                case 'userAccount_overview':
                    page = '账户总览'
                    break
            }
            let row = this.orderInfo.order
            console.log(row)
            zhuge.track(traceText, {
                '页面名称': page,
                '付费方式': row.payType === 1 ? '支付宝': row.payType === 2 ? '微信' : row.payType === 3 ? '银行卡' : '',
                '套餐名称':  row.suiteConfigTitle || '',
                '服务包名称': row.suiteName,
                '时间戳个数': row.tsCount,
                '服务包金额': row.dueAmount,
            }, () => {
                continuePayOredrCommon(this.orderInfo)
            })
        },
        async getOrderInfo(){
            this.countdownText = ''
            this.timer && clearInterval(this.timer)
            try {
                let res= await getPendingPaymentOrder();
                // 其实就是 count > 0
                if (res.count) {
                    this.show = true
                    this.orderInfo = res;
                    // 过期时间
                    let paymentExpiredAt = this.orderInfo.order.paymentExpiredAt
                    // 系统当前时间
                    this.serverDateTime = this.orderInfo.serverDateTime
                    if (paymentExpiredAt - this.serverDateTime <= 0) {
                        this.show = false
                        return
                    }
                    this.countdown(paymentExpiredAt)
                    this.timer = setInterval(() => {
                        this.countdown(paymentExpiredAt)
                    }, 1000)
                } else {
                    this.show = false
                }
                
            } catch (error) {
                console.log(error)
            }
        },
        countdown (paymentExpiredAt) {
            const distance = paymentExpiredAt - this.serverDateTime;
            // 如果倒计时结束
            if (distance <= 0) {
                clearInterval(this.timer);
                this.getOrderInfo()
                
                return
            }
            // 时间计算
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            this.countdownText = `${days > 0 ? days + '天' : ''}${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`
            this.serverDateTime += 1000
            
        },
        close () {
            this.show = false
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-pendingPaymentTip {
        width: 100%;
        height: 56px;
        background: #FFF6E6;
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin-bottom: 13px;
        .left {
            flex: 1;
            .single-container {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                padding: 0 18px;
                box-sizing: border-box;
                .name {
                    color: #000000;
                    font-size: 14px;
                    margin-right: 17px;
                    span {
                        font-weight: bold;
                        color: #F33E3E;
                        font-size: 16px;
                    }
                    .size20 {
                        font-size: 16px;
                    }
                }
                .btn {
                    width: 105px;
                    height: 40px;
                    background: #FEA813;
                    border-radius: 6px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    &:hover {
                        background: #ef9c0d;
                    }
                    span {
                        font-size: 14px;
                        color: #FFFFFF;
                    }
                }
            }
            .multiple-container {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                padding-left: 18px;
                box-sizing: border-box;
                .pending-number {
                    flex-shrink: 0;
                    display: flex;
                    align-items: center;
                    margin-right: 20px;
                    cursor: pointer;
                    p {
                        color: #005CE6;
                        font-size: 16px;
                    }
                    .bold {
                        font-weight: bold;
                        font-size: 24px;
                    }
                    .el-icon-arrow-right {
                        color: #005CE6;
                        font-size: 16px;
                        margin-left: 4px;
                        flex-shrink: 0;
                    }
                }
                .order-info {
                    flex-shrink: 0;
                    margin-right: 45px;
                    p {
                        color: #000000;
                        font-size: 14px;
                        span {
                            font-weight: bold;
                            color: #F33E3E;
                            font-size: 16px;
                        }
                    }
                }
                .timestamp-count {
                    display: flex;
                    align-items: center;
                    flex-shrink: 0;
                    p {
                        font-size: 14px;
                        color: #151B26;
                        margin-right: 48px;
                        &:last-child {
                            margin-right: 37px;
                        }
                        span {
                            font-weight: bold;
                            font-size: 16px;
                            color: #F33E3E;
                        }
                    }
                }
                .btn-group {
                    flex-shrink: 0;
                    display: flex;
                    align-items: center;
                    p {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 104px;
                        height: 40px;
                        background: #FFFFFF;
                        border-radius: 6px;
                        cursor: pointer;
                    }
                    .cancel {
                        border: 1px solid #E8E9EB;
                        background: #FFFFFF;
                        box-sizing: border-box;
                        margin-right: 16px;
                        &:hover {
                            border: 1px solid #FEA813;
                            span {
                                color: #FEA813;
                            }
                        }
                        span {
                            font-size: 14px;
                            color: #151B26;
                        }
                    }
                    .confirm {
                        border: 1px solid #FEA813;
                        background: #FEA813;
                        box-sizing: border-box;
                        &:hover {
                            background: #ef9c0d;
                        }
                        span {
                            font-size: 14px;
                            color: #ffffff;
                        }
                    }
                }
            }
        }
        .el-icon-close {
            flex-shrink: 0;
            font-size: 20px;
            cursor: pointer;
            color: #5A5A68;
            margin-right: 32px;
            margin-left: 10px;
        }
    }
    @media screen and (max-width: 1360px) {
        .tsa-pendingPaymentTip {
            .left {
                .multiple-container {
                    box-sizing: border-box;
                    .pending-number {
                        margin-right: 2px;
                    }
                    .order-info {
                        margin-right: 20px;
                    }
                    .timestamp-count {
                        p {
                            margin-right: 15px;
                            &:last-child, &:first-child {
                                margin-right: 15px;
                            }
                        }
                    }
                    .btn-group {
                        p {
                            width: 90px;
                        }
                        .cancel {
                            margin-right: 8px;
                        }
                    }
                }
            }
            .el-icon-close {
                margin-right: 15px;
            }
        }
    }
    @media screen and (max-width: 1530px) {
        .tsa-pendingPaymentTip {
            &.userAccount_overview {
                .left {
                    .multiple-container {
                        .pending-number {
                            margin-right: 15px;
                        }
                        .order-info {
                            // margin-right: 20px;
                        }
                        .timestamp-count {
                            p {
                                &:last-child, &:first-child {
                                    margin-right: 15px;
                                }
                            }
                        }
                    }
                }
                .el-icon-close {
                    margin-right: 15px;
                }
            }
        }
    }
    @media screen and (max-width: 1460px) {
        .tsa-pendingPaymentTip {
            &.userAccount_overview {
                .left {
                    .multiple-container {
                        .pending-number {
                            margin-right: 6px;
                            p {
                            }
                        }
                        .order-info {
                            margin-right: 20px;
                            p {
                                span {
                                    font-size: 18px;
                                }
                            }
                        }
                        .timestamp-count {
                            p {
                                &:last-child, &:first-child {
                                    margin-right: 15px;
                                }
                            }
                        }
                        .btn-group {
                            p {
                                width: 90px;
                                span {
                                    font-size: 13px;
                                }
                            }
                            .cancel {
                                margin-right: 8px;
                            }
                        }
                    }
                }
                .el-icon-close {
                    margin-right: 15px;
                }
            }
        }
    }
    @media screen and (max-width: 1380px) {
        .tsa-pendingPaymentTip {
            &.userAccount_overview {
                .left {
                    .multiple-container {
                        .pending-number {
                            margin-right: 6px;
                            p {
                                font-size: 14px;
                                span {
                                    font-size: 14px;
                                }
                                .bold {
                                    font-size: 18px;
                                }
                            }
                        }
                        .order-info {
                            margin-right: 20px;
                            p {
                                font-size: 14px;
                                span {
                                    font-size: 18px;
                                }
                            }
                        }
                        .timestamp-count {
                            p {
                                &:last-child, &:first-child {
                                    margin-right: 15px;
                                }
                            }
                        }
                        .btn-group {
                            p {
                                width: 90px;
                                span {
                                    font-size: 13px;
                                }
                            }
                            .cancel {
                                margin-right: 8px;
                            }
                        }
                    }
                }
                .el-icon-close {
                    margin-right: 15px;
                }
            }
        }
    }
</style>